export const TOAST_MESSAGES ={
    TASK_MASTER_FETCH_FAILED: "Failed to fetch Tasks",
    TASK_MASTER_FETCH_ERROR: "Error fetching Tasks",
    SUB_TASK_FETCH_FAILED: "Failed to fetch Sub-tasks",
    SUB_TASK_FETCH_ERROR: "Error fetching Sub-tasks",
    CREATE_TASK_MASTER_SUCCESS: "Task Master created successfully",
    CREATE_TASK_MASTER_FAILED: "Failed to create Task",
    CREATE_TASK_MASTER_ERROR: "Error creating Task",
    CREATE_SUB_TASK_SUCCESS: "Sub-task created successfully",
    CREATE_SUB_TASK_FAILED: "Failed to create Sub-task",
    CREATE_SUB_TASK_ERROR: "Error creating Sub-task",
    UPDATE_TASK_MASTER_SUCCESS: "Task updated successfully",
    UPDATE_TASK_MASTER_FAILED: "Failed to update Task",
    UPDATE_TASK_MASTER_ERROR: "Error updating Task",
    UPDATE_SUB_TASK_SUCCESS: "Sub-task updated successfully",
    UPDATE_SUB_TASK_FAILED: "Failed to update Sub-task",
    UPDATE_SUB_TASK_ERROR: "Error updating Sub-task",
    DELETE_TASK_MASTER_SUCCESS: "Task deleted successfully",
    DELETE_TASK_MASTER_FAILED: "Failed to delete Task",
    DELETE_TASK_MASTER_ERROR: "Error deleting Task",
    DELETE_SUB_TASK_SUCCESS: "Sub-task deleted successfully",
    DELETE_SUB_TASK_FAILED: "Failed to delete Sub-task",
    DELETE_SUB_TASK_ERROR: "Error deleting Sub-task",
}

export const NO_TASKS_FOUND = "No Task Masters found";

export const PROJECT_TYPE = {
  SOLAR: "Solar",
  EV: "EV",
  BOTH: "Both",
  OTHER: "Other",
};

export const CATEGORY_TYPE = {
  RESIDENTIAL: "Residential",
  COMMERCIAL: "Commercial",
  INDUSTRIAL: "Industrial",
  OTHER: "Other",
};